// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_gN","advertCardFooter__row":"c-a_gO","advertCardFooter__name":"c-a_gP","advertCardFooter__price":"c-a_gQ","advertCardFooter__age":"c-a_gR"};